/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:26
 * @LastEditTime: 2020-03-26 14:32:41
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\manageConfig\tenantManageMent\manuAccessSetting\manuAccessSetting.js
 * @Description: 
 */
/**
 * 描述：租户管理--稿件接入设置
 * 日期：2017-10-13
 * 作者：liu_jinming
 */
'use strict';
angular.module('manuAccessSettingModule', [])
    .controller('manuAccessSettingCtrl', ['$scope', '$q', 'tManageMentService', 'modalDialog', 'trsHttpService', '$state', function ($scope, $q, tManageMentService, modalDialog, trsHttpService, $state) {
        initStatus();
        initData();

        /** [initStatus description: 初始化状态] */
        function initStatus() {
            $scope.data = {
                tenantIP: '',
                TENANTNAME: ''
            };
        }

        /** [initData description：初始化数据] */
        function initData() {
            requestData();
            $scope.$parent.setSelectedOption('manuAccessSetting', '稿件接入设置');
        }

        /**
         * [requestData description]
         * @return  {[type]}  [return description]
         */
        function requestData() {
            var params = {
                'serviceid': 'mlf_tenant',
                'methodName': 'findTenantById'
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.data.TENANTNAME = data.TENANTNAME;
                var params = {
                    'serviceid': 'mlf_tenantuploadmanage',
                    'methodName': 'queryTenantUploadManage',
                    'TENANTNAME': data.TENANTNAME
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (res) {
                    if (angular.isArray(res)) { // 因为后端的不正常规格数据返回做了如此判断
                        $scope.data.tenantIP = res[0].IP;
                    } else {
                        $scope.data.tenantIP = '还未配置IP地址，请先下载工具包并按工具包中的要求完成操作';
                    }
                });
            });
        }

        /**
         * [changeIP description]
         * @param   {[type]}  item  [item description]
         * @param   {[type]}  num   [num description]
         * @return  {[type]}        [return description]
         */
        $scope.changeIP = function (item, num) {
            if (num === '3' && $scope.data.tenantIP != '还未配置IP地址，请先下载工具包并按工具包中的要求完成操作') {
                modalDialog.alertType('', '已存在IP,无法新增', 'warning', false);
            } else if (num === '1' && $scope.data.tenantIP == '还未配置IP地址，请先下载工具包并按工具包中的要求完成操作') {
                modalDialog.alertType('', '不存在IP,请先添加IP', 'warning', false);
            } else {
                tManageMentService.smsVerification(item, num).then(function () {
                    requestData();
                });
            }
        };
        $scope.downZip = function () {
            window.open('/wcm/xjmediaCloud/uploadConfigInfo/download');
        };
    }]);
